import React, { useRef } from "react";
import "devextreme/dist/css/dx.light.css";
import {
  Column,
  Selection,
  FilterRow,
  Paging,
  ColumnChooser,
  Pager,
  Scrolling,
  SearchPanel,
  GroupPanel,
  Grouping,
  StateStoring,
} from "devextreme-react/data-grid";
import {
  HeaderFilter,
  FilterPanel,
  FilterBuilderPopup,
  Export,
} from "devextreme-react/data-grid";
import BaseDataGrid from "../../components/BaseDataGrid";

export default function OrderDetailBillingList(props) {
  const dataTable = useRef(null);
  const gridHeight = "20vh";

  return (
    <BaseDataGrid
      className="gridContainer"
      ref={dataTable}
      dataSource={props.bills}
      showBorders={true}
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnResizingMode="widget"
      columnAutoWidth={true}
      height={gridHeight}
      keyExpr="id"
      width="100%"
      style={{
        maxWidth: "100%",
        overflowX: "auto",
      }}
    >
      <FilterPanel visible={false} />
      <HeaderFilter visible={false} />
      <GroupPanel visible={false} />

      <Selection mode="single" />
      <FilterRow visible={false} />
      <Paging defaultPageSize={10} />
      <Pager
        visible={false}
        allowedPageSizes={[20, 35, 60, "all"]}
        showPageSizeSelector={true}
        showInfo={true}
        infoText="Page #{0}. Total: {1} ({2} items)"
        displayMode="full"
      />

      <Scrolling rowRenderingMode="virtual"></Scrolling>

      <Column dataField="title" caption="Title" minWidth={160} />
      <Column dataField="details" caption="Details" minWidth={160} />
      <Column
        dataField="dollarValue"
        caption="Dollar Value"
        alignment="center"
        minWidth={100}
      />
      <Column dataField="notes" caption="Notes" />
    </BaseDataGrid>
  );
}
